import Vue from "vue";
import ImageScroll from './ImageScroll';
import EmployeeSlider from '@/components/EmployeeSlider/EmployeeSlider.vue';
export default Vue.extend({
    name: 'HeroSection',
    components: {
        EmployeeSlider
    },
    props: {
        dir: { type: String },
        prefix: { type: String },
        ext: { type: String },
        items: { type: Number }
    },
    data() {
        return {
            images: [],
            imageScroll: null,
            imageAnimationVisible: window.innerWidth < 640 ? false : true
        };
    },
    beforeMount() {
        this.preload();
    },
    methods: {
        triggerImageScroll(randomizedImages) {
            this.imageScroll = new ImageScroll(randomizedImages);
            this.imageAnimationVisible = true;
        },
        preload() {
            var loadImages = new Array();
            for (let i = 0; i < this.items; i++) {
                if (i >= 8 && i < 14) {
                    continue;
                }
                this.images[i] = new Image();
                var imageId = (i < 9) ? "0" + (i + 1) : i + 1;
                var src = this.dir + this.prefix + imageId + '.' + this.ext;
                this.images[i].src = src;
            }
        }
    },
    watch: {
        imageScroll: {
            handler(newVal, oldVal) {
                this.currentImage = newVal.currentImage;
            },
            deep: true
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/HeroSection/HeroSection.ts
// module id = null
// module chunks = 